<script lang="ts" context="module">
	import Button from "./Button.svelte";
</script>

<script lang="ts">
	export let url: URL;
</script>

<div class="hidden sm:flex lg:w-[240px]">
	<Button
		{url}
		title="Start a Newsletter"
		icon="edit"
		textSize="15"
		iconOpacity={0.5}
		iconResponsiveness="md"
		chevron="right"
		chevronResponsiveness="md"
		style="orange"
		width="full" />
</div>
